import { styled } from '@linaria/react';

export const Fieldset = styled.fieldset`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const Form = styled.form`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;
